import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { pushEvent } from '../utils/analytics';

// Global sticky "Find Stores" CTA for mobile.
// Hidden on routes that already have their own sticky (/horeca) or that
// are the target itself (/find-us). Reveals after the user has scrolled
// past the initial viewport height.
const HIDDEN_ROUTES = new Set(['/find-us', '/horeca']);

const MobileStickyCta = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (HIDDEN_ROUTES.has(pathname)) return null;

  return (
    <div
      className={`nb-mobile-sticky ${visible ? 'is-visible' : ''}`}
      role="complementary"
      aria-hidden={!visible}
      data-testid="mobile-sticky-cta"
    >
      <Link
        to="/find-us"
        className="nb-cta-primary"
        data-testid="mobile-sticky-find-stores"
        onClick={() => pushEvent('find_store_click', { button_location: 'mobile_sticky' })}
      >
        <MapPin size={16} aria-hidden="true" /> Find Stores <ArrowRight size={16} aria-hidden="true" />
      </Link>
    </div>
  );
};

export default MobileStickyCta;
